module.exports = __webpack_public_path__ + "images/accents/accent-review-discussion@2x-fe147bad9029f716486c4332254b6358.webp";